import React from 'react'
import filter_color from "../../assets/images/design/colorFilter.svg"
import hr_document_security from "../../assets/images/contents/hr-document-security.png"
import { PrimaryButton, PrimaryButton2th } from '../../components/StyledButtons'
import WhitepaperDownloadForm from './WhitepaperDownloadForm'
import OtherWhitepapers from './OtherWhitepapers'
import testing_inspection_whitepaper from "../../assets/images/contents/testing-inspection-whitepaper.png"
import document_security_2023 from "../../assets/images/contents/document-security.png"
import banking_whitepaper from "../../assets/images/contents/banking-whitepaper.png"
import Navbar from '../../components/Navbar'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import { useTranslation } from 'react-i18next'


const HrDocumentSecurity = () => {
  const handleScroll = () => {
    const targetElement = document.getElementById('download-whitepaper-form');
    if (targetElement) {
        const yOffset = 0;
        const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }
};
  
  const { t } = useTranslation()

  const items = [
    {
      id: 1,
      link: '/whitepapers/testing-inspection',
      image: testing_inspection_whitepaper,
      chip: t("whitepapers-tab.testing-inspection-whitepaper"),
      title: t('whitepapers.testing-inspection-title'),
      content: t('whitepapers.testing-inspection-content'),
    },
    {
      id: 2,
      link: '/whitepapers/document-security',
      image: document_security_2023,
      chip: t("whitepapers-tab.document-security-whitepaper"),
      title: t('whitepapers.document-security-title'),
      content: t('whitepapers.document-security-content')
    },
    {
      id: 3,
      link: '/whitepapers/banking',
      image: banking_whitepaper,
      chip: t("whitepapers-tab.banking-whitepaper"),
      title: t('whitepapers.banking-title'),
      content: t('whitepapers.banking-content')
    },
  ];

  return (
    <div className='hr-document-security bg-primary'>
      <div className='color-filter-right' style={{ top: "45%" }}>
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "55%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>

      <Navbar />
      <div className='container-fluid hr-document-security-header'>
        <div className='container pt-100 pt-md-150'>
          <div className='col-sm-12 col-xl-7 px-md-0 pt-f768-t991-0'>
            <p className='font-64 font-weight-semi-bold header-sub-title'>{t('whitepapers.hr-document-security.title')}</p>
            <p className='font-60 font-weight-semi-bold header-title'>{t("whitepapers.download-whitepaper-for-free")}</p>
            <p className='pt-30 text-white'>{t('whitepapers.hr-document-security.sub-title')}</p>
            <div className='pt-30'>
              <PrimaryButton onClick={handleScroll}>{t('button.download-whitepaper-for-free')}</PrimaryButton>
            </div>
          </div>
          <div className='col-sm-12 col-xl-5 pt-50 pt-xl-0 px-xl-0'>
            <div className='flex justify-center' >
              <img src={hr_document_security} alt="hr-document-security" className='img-responsive img-header' />
              <div className='hr-document-security-behind-line'></div>
            </div>
          </div>
        </div>
      </div>
      <div className='container pt-70'>
        <div className='look-inside col-sm-12'>
          <div className='col-xl-5'>
            <div className='flex justify-center'>
              <img src={hr_document_security} alt="qr_code_1" className='img-responsive' />
            </div>
          </div>
          <div className='col-xl-7'>
            <p className='font-32 font-weight-semi-bold'>{t("whitepapers.looking-inside-the-whitepaper")}</p>
            <p className='pt-20'>
            {t('whitepapers.hr-document-security.content-1')}
            </p>
            <p className='pt-20'>{t('whitepapers.hr-document-security.content-2')}</p>
            <div className='pt-20'>
              <PrimaryButton2th onClick={handleScroll}>{t('button.download-whitepaper-for-free')}</PrimaryButton2th>
            </div>
          </div>
        </div>
      </div>

      <WhitepaperDownloadForm />

      <OtherWhitepapers items={items} />

      <div className='container'>
        <IndustriesImageContainer />
      </div>
      <Footer />
    </div>
  )
}

export default HrDocumentSecurity